import template from './exploreTrendWidgetsNg1.jade';

class ExploreTrendWidgetsControllerNg1 {

    constructor(Resource, $q, $timeout, $filter, $stateParams, featureFlagsHelper, currentExploreGroupForCharts, UserExplorerResource, userExploreConstants) {
        this.hiddenComparisonTrends = featureFlagsHelper.getFlagByKey('PlayerExplorerHiddenComparisonTrends').active;
        this.Resource = Resource;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.currentExploreGroupForCharts = currentExploreGroupForCharts;
        this.UserExplorerResource = UserExplorerResource;
        this.userExploreConstants = userExploreConstants;
        this.trendsWithHiddenComparison = ['gender', 'apps', 'countries', 'deviceType', 'os'];
        this.trendsWithFixedSeries = {
          gender: { key1: 'male', key2: 'female'},
          deviceType: { key1: 'Smartphone', key2: 'Tablet'},
          os: { key1: 'iOS', key2: 'Android'}
        };

        this.deferredGender = $q.defer();


      this.series = {
            activeDays: [{
                type: 'area',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'ACTIVE_DAYS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'activeDays'))
            }],
            age: [{
                stickyTracking: false,
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'AGE'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'age'))
            }],
            sessionsPerDay: [{
                type: 'area',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'APP_ENGAGEMENT'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'sessionsPerDay'))
            }],
            played_genres: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'GENRE'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'sessionsPerDay'))
            }],
            apps: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'NUMBER_OF_APPS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'apps'))
            }],
            other_apps: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'OTHER_APPS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'other_apps'))
            }],
            paying: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'PAYERS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'paying'))
            }],
            revenue: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'REVENUE'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'revenue')),
                format: (() => 'USD')
            }],
            conversion_rate: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'CONVERSION_RATE'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'conversion_rate'))
            }],
            transaction: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'TRANSACTIONS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'transaction'))
            }],
            os: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'DEVICE_OS'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'os'))
            }],
            countries: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'COUNTRY'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'countries'))
            }],
            gender: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'GENDER'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'gender'))
            }],
            deviceType: [{
                type: 'spline',
                format: 'number',
                getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'trends', {trend_dimension: 'DEVICE_TYPE'})),
                transformResponse: ((res) => this.transformTrendSeriesResponse(res, 'deviceType'))
            }]
        };
    }

  transformTrendSeriesResponse(res, metric) {
    let processedSeries = [];
    if(_.includes(_.keys(this.trendsWithFixedSeries), metric)){
        _.forEach(this.trendsWithFixedSeries[metric], (seriesNames) => {
          processedSeries.push({data: { key:seriesNames, tooltipName: seriesNames, rows:res[0].timeseries[seriesNames], summary: {} }});
          // For the moment removing benchmark series
          // processedSeries.push({data: { key:'Benchmark ' + seriesNames, tooltipName: 'Benchmark ' + seriesNames, rows:res[0].benchmark_timeseries[seriesNames], summary: {} }});
        });
    } else {
      _.forEach(res[0].timeseries, (trendPoints, originalTrendName) => {
        let UiTrendName = '';
        if(metric == 'age') {
          UiTrendName = this.getAgeBucketStringFromDriudBucket(originalTrendName);
        } else if(metric == 'other_apps') {
          UiTrendName = trendPoints[0] ? trendPoints[0].app_name : '';
        } else {
          UiTrendName = originalTrendName;
        }
        processedSeries.push({ data: { key:UiTrendName, tooltipName: UiTrendName, rows:trendPoints, summary: {} } });

        // if(res[0].benchmark_timeseries[originalTrendName]) {
        //   processedSeries.push({data: { key:'Benchmark ' + UiTrendName, tooltipName: 'Benchmark ' + UiTrendName, rows: res[0].benchmark_timeseries[originalTrendName], summary: {} }});
        // } else {
        //   processedSeries.push({data: { key:'Benchmark ' + UiTrendName, tooltipName: 'Benchmark ' + UiTrendName, rows: [], summary: {} }});
        // }

      });
    }

    if(this.hiddenComparisonTrends && _.includes(this.trendsWithHiddenComparison, metric)) {
      _.forEach(processedSeries, (processedSerie, index) => {
        if(index % 2 == 0) {
          processedSerie.data.events = {
            mouseOver: function() {
              this.mouseWasOver = true;
              this.chart.series[this.index + 1].options.color = 'rgba(170, 170, 170, 1)';
              this.chart.series[this.index + 1].update(this.chart.series[this.index + 1].options);
            },
            mouseOut: function() {
              if(this.mouseWasOver) {
                this.mouseWasOver = false;
                this.chart.series[this.index + 1].options.color = 'rgba(170, 170, 170, 0)';
                this.chart.series[this.index + 1].update(this.chart.series[this.index + 1].options);
              }
            }
          };
        } else {
          processedSerie.data.hideLegend = true;
          processedSerie.data.color = 'rgba(170, 170, 170, 0)';
        }
      });
    }

    return processedSeries;
  }

  getAgeBucketStringFromDriudBucket(trendName) {
      if(this.userExploreConstants.ageDriudBucketNameToRange[trendName]) {
        if(this.userExploreConstants.ageDriudBucketNameToRange[trendName].to) {
          return this.userExploreConstants.ageDriudBucketNameToRange[trendName].from + ' - ' + this.userExploreConstants.ageDriudBucketNameToRange[trendName].to
        } else {
          return this.userExploreConstants.ageDriudBucketNameToRange[trendName].from + '+'
        }
      } else {
        return trendName;
      }
  }

}

let ExploreTrendWidgetsComponentNg1 = {
    template: () => { return template },
    controller: ExploreTrendWidgetsControllerNg1,
    controllerAs: 'vm',
    bindings: {
        activeChartsTab: '='
    }
};

export default angular.module('app.components.explore.trendWidgets', [])
    .component('exploreTrendWidgetsNg1', ExploreTrendWidgetsComponentNg1);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreTrendWidgetsNg1.js
 **/